<script lang="ts">
export default {
  name: 'SearchKeywordImpressionLabelForm',
}
</script>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { KkBox, KkButton, KkLoading } from 'src/biz_spa/components/base'
import { KkSearchKeywordImpressionLabelForm } from 'src/biz_spa/domains/management/components'
import { useSearchKeywordImpressionLabels } from 'src/biz_spa/domains/management/composables'
import type { SearchKeywordImpressionLabelKeyword, SearchKeywordImpressionLabelId } from 'src/biz_spa/types'

const route = useRoute()
const router = useRouter()
const { readLabel, getLabel, updateLabel, isLoading, isSubmitting, companyUuid } = useSearchKeywordImpressionLabels()

const keywords = ref<SearchKeywordImpressionLabelKeyword[]>([])

const labelId = computed<SearchKeywordImpressionLabelId>(() => {
  const id = String(route.params.label_id)
  if (['branded', 'selected'].includes(id) ) return id as 'branded' | 'selected'
  return Number(id)
})

const label = computed(() => getLabel(labelId.value))

const initialized = async () => {
  await readLabel(labelId.value)
  if (label.value && label.value.keywords.length) {
    keywords.value = label.value.keywords.map((keyword) => ({ id: keyword.id, keyword: keyword.keyword }))
  } else {
    keywords.value = [{ id: 1, keyword: '' }]
  }
}

const handleSubmit = async () => {
  await updateLabel(labelId.value, keywords.value)
  router.push({
    name: 'CompaniesSearchKeywordImpressionLabels',
    params: {
      company_uuid: companyUuid.value,
    },
  })
}

initialized()
</script>

<template>
  <KkBox>
    <template #content>
      <KkLoading v-if="isLoading" />
      <KkBox v-else-if="label" :title="$t('pages.companies.searchKeywordImpressionLabelEdit.sectionTitle', { title: label.title })" border>
        <template #content>
          <KkSearchKeywordImpressionLabelForm v-model="keywords" />
        </template>
      </KkBox>
    </template>
    <template #footer>
      <div :class="$style.buttons">
        <KkButton :text="$t('labels.cancel')" color="secondary" />
        <KkButton :text="$t('labels.confirm')" :disabled="isSubmitting" color="primary" @click="handleSubmit" />
      </div>
    </template>
  </KkBox>
</template>

<style lang="scss" module>
.buttons {
  display: flex;
  gap: 0 16px;
  justify-content: flex-end;
  align-items: center;
}
</style>
